import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { fallbackLocale, localeFromDomain } from 'frontend-resources/js/Helpers/Locales';
import messages from '@/config/messages';
import './vue-html-safe-directive';

Vue.use(VueI18n);

export default ({ app, store }) => {
    const locale = (store.user || {}).locale || localeFromDomain();

    store.commit('SET_LANG', locale);
    app.i18n = new VueI18n({
        locale,
        fallbackLocale: fallbackLocale(),
        messages: messages,
    });
    app.head.htmlAttrs = {
        lang: locale,
    };
};
